export default {
  headline: 'Benutzer-Abonnements',
  subheadline: 'Einrichten Benutzer-Abonnements',
  noUserSelected: 'Bitte wählen Sie einen Benutzer',
};
